import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant14() {
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center justify-center text-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-423">
        {/* Massive Background Text */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 0.05,
        scale: 1
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[30rem] font-black text-blue-600 pointer-events-none select-none leading-none" data-id="element-424">
          $0
        </motion.div>

        <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4" data-id="element-425">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="mb-8" data-id="element-426">
            <span className="inline-block text-8xl md:text-[10rem] font-black text-transparent bg-clip-text bg-gradient-to-b from-gray-900 to-gray-500 tracking-tighter leading-none mb-4" data-id="element-427">
              $0
            </span>
            <div className="text-xl md:text-2xl font-bold text-gray-500 uppercase tracking-widest" data-id="element-428">
              Стоимость разработки
            </div>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mb-6 text-3xl md:text-5xl font-bold leading-tight text-gray-900 max-w-3xl" data-id="element-429">
            Мы сделаем вам сайт бесплатно.
            <br data-id="element-430" />
            Вы платите только <span className="text-blue-600" data-id="element-431">
              {price}/мес
            </span>{' '}
            за его работу.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-lg md:text-xl mb-10 text-gray-600 font-medium max-w-2xl" data-id="element-432">
            Сначала макет — потом решение. Не понравится — уходишь без оплаты.
            Никаких скрытых платежей.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-433">
            <button onClick={() => setIsPopupOpen(true)} className="group relative flex items-center justify-center gap-2 rounded-full px-10 py-5 font-bold text-xl transition-all hover:scale-105 overflow-hidden shadow-2xl shadow-blue-500/30" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-434">
              Получить бесплатный макет
              <ArrowRightIcon className="w-6 h-6 transition-transform group-hover:translate-x-2" data-id="element-435" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-436" />
    </>;
}